<template>
    <div ref="map" :style="{height: height, width: width}"></div>
</template>

<script>
export default {
  name: "HereMapRoute",
  props: {
    appId: String,
    appCode: String,
    mode: String,
    lng: Number,
    lat: Number,
    waypoint0: String,
    waypoint1: String,
    zoom: { type: Number, default: 10 },
    timeOut: { type: Number, default: 0 },
    theme: String,
    ancore: { type: String, default: "" }
  },
  data() {
    return {
      defaultLayers: null,
      height: 0,
      width: 0,
      w_old0: null,
      w_old1: null,
      map: {},
      platform: {}
    };
  },
  watch: {
    waypoint0(val) {
        const [lat, lng] = val.split(',')
        const tmpOb = { lat, lng }
        this.w_0 = tmpOb     
        this.addMark()
        if (this.w_0 && this.w_1) this.calcRoute()
    },
    waypoint1(val) {
        const [lat, lng] = val.split(',')
        const tmpOb = { lat, lng }
        this.w_1 = tmpOb     
        this.addMark()
        if (this.w_0 && this.w_1) this.calcRoute()
    },
  },
  computed: {
    coordinates() {
      return {
        lng: this.lng || '15.6548623',
        lat: this.lat || '38.1027666'
      };
    },
    mapOptions() {
      return {
        zoom: this.zoom,
        center: this.coordinates
      };
    }
  },
  created() {
    this.platform = new H.service.Platform({
      app_id: this.appId,
      app_code: this.appCode
    });
  },
  mounted() {
      this.calcP()
    setTimeout(() => {
      this.map.getViewPort().resize();
    }, this.timeOut);
    
    this.initMap();    
    
    window.addEventListener('resize', () => {
      this.map.getViewPort().resize();
    });
  },
  methods: {
      calcP () {
        this.height = "70vh";
        this.width = document.getElementById(this.ancore).clientWidth + "px";
      },
    initMap() {
    this.defaultLayers = this.platform.createDefaultLayers();
      this.map = new H.Map(
        this.$refs.map,
        this.defaultLayers.normal.map,
        this.mapOptions
      );
      this.map.setBaseLayer(this.defaultLayers.normal.traffic);
      this.map.addLayer(this.defaultLayers.incidents);

      const pixelRatio = window.devicePixelRatio || 1;
      const tileSize = pixelRatio === 1 ? 256 : 512;
      const ppi = pixelRatio === 1 ? undefined : 320;

      let mapTileService = this.platform.getMapTileService({
        type: "base"
      });

      // Our layer will load tiles from the HERE Map Tile API
      let mapLayer = mapTileService.createTileLayer(
        "maptile",
        "normal.day",
        tileSize,
        "png8",
        { lg: "VIE", ppi: ppi }
      );

      this.map.setBaseLayer(mapLayer);

        const events = new H.mapevents.MapEvents(this.map);
        const behavior = new H.mapevents.Behavior(events);
        const ui = H.ui.UI.createDefault(this.map, this.defaultLayers);
    },
    addMark () {
      this.map.removeObjects(this.map.getObjects());
      if (this.w_0) {
        const marker0 = new H.map.Marker(this.w_0);
        this.map.addObject(marker0);  
        this.map.setCenter(this.w_0)
        this.map.setZoom(this.zoom)
      }
      if (this.w_1) {
        const marker1 = new H.map.Marker(this.w_1);
        this.map.addObject(marker1);  
      }
    },
    calcRoute() {
        console.log('calcRoute');
        let vm = this;
      const routingParameters = {
        mode: this.mode || "fastest;car",
        representation: "display",
        routeattributes: "waypoints,summary,shape,legs",
        maneuverattributes: "direction,action",
        waypoint0: this.waypoint0,
        waypoint1: this.waypoint1
      };

      const onResult = function(result) {
        let route, routeShape, startPoint, endPoint, linestring;

        if (result.response.route) {
          // Pick the first route from the response:
          route = result.response.route[0];
          // Pick the route's shape:
          routeShape = route.shape;

          // Create a linestring to use as a point source for the route line
          linestring = new H.geo.LineString();

          // Push all the points in the shape into the linestring:
          routeShape.forEach(function(point) {
            let parts = point.split(",");
            linestring.pushLatLngAlt(parts[0], parts[1]);
          });

          // Retrieve the mapped positions of the requested waypoints:
          startPoint = route.waypoint[0].mappedPosition;
          endPoint = route.waypoint[1].mappedPosition;

          // Create a polyline to display the route:
          let routeLine = new H.map.Polyline(linestring, {
            style: { lineWidth: 10 },
            arrows: {
              fillColor: "white",
              frequency: 2,
              width: 0.8,
              length: 0.7
            }
          });

          // Create a marker for the start point:
          let startMarker = new H.map.Marker({
            lat: startPoint.latitude,
            lng: startPoint.longitude
          });

          // Create a marker for the end point:
          let endMarker = new H.map.Marker({
            lat: endPoint.latitude,
            lng: endPoint.longitude
          });

          // Add the route polyline and the two markers to the map:
          vm.map.addObjects([routeLine, startMarker, endMarker]);

          // Set the map's viewport to make the whole route visible:
          vm.map.setViewBounds(routeLine.getBounds());
        }
      };

      const onError = error => {
        alert(error);
      };

      // Get an instance of the routing service:
      var router = this.platform.getRoutingService();

      // Call calculateRoute() with the routing parameters,
      // the callback and an error callback function (called if a
      // communication error occurs):
      router.calculateRoute(routingParameters, onResult, onError);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/MapHere/components/HereMapRoute.vue